import React from 'react';
import { productHighlightPropTypes } from '@Theme/natucare/modules/ProductHighlight/ProductHighlightPropTypes';
import Container from '@Theme/natucare/components/Container/Container';
import Button from '@Theme/natucare/components/Button/Button';
import Icon from '@Theme/natucare/components/Icon/Icon';
import * as styles from './ProductHighlight.module.scss';
const ProductHighlight = _ref => {
  let {
    subheading,
    heading,
    cols,
    buttons
  } = _ref;
  return /*#__PURE__*/React.createElement("section", {
    className: styles.root
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
    className: styles.rootSubheading,
    dangerouslySetInnerHTML: {
      __html: subheading
    }
  }), /*#__PURE__*/React.createElement("h2", {
    className: styles.rootHeading,
    dangerouslySetInnerHTML: {
      __html: heading
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.rootItemsWrapper
  }, cols.map((_ref2, index) => {
    let {
      items
    } = _ref2;
    return /*#__PURE__*/React.createElement("div", {
      className: styles.rootItems,
      key: index
    }, items.map((_ref3, index) => {
      let {
        heading,
        text,
        icon
      } = _ref3;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.rootItem,
        key: index
      }, (icon === null || icon === void 0 ? void 0 : icon.path) && /*#__PURE__*/React.createElement(Icon, {
        path: icon === null || icon === void 0 ? void 0 : icon.path,
        viewBox: icon === null || icon === void 0 ? void 0 : icon.viewBox
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.rootItemText
      }, /*#__PURE__*/React.createElement("h3", null, heading), /*#__PURE__*/React.createElement("p", null, text)));
    }));
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.rootButtonWrapper
  }, buttons.map((_ref4, index) => {
    let {
      href,
      label
    } = _ref4;
    return /*#__PURE__*/React.createElement(Button, {
      variant: index ? 'secondaryOrange' : 'primaryOrange',
      href: href,
      label: label,
      key: index
    });
  }))));
};
export default ProductHighlight;